import Vue from "vue";
import Vuex from "vuex";
// import Axios from "axios";
// import axios from "axios";
import { horaActual } from './metodos'

Vue.use(Vuex)

// const urlAPI = "http://192.168.1.90:3300/" // Adal puerto 3300
// const urlApi = "https://soti.com.mx/Sistema/restfull" // HOSTING
// const urlApi = "https://192.168.1.204:80/restfull" //NADIA PHP
// const urlApi = "http://192.168.1.164/restfull"
// const urlApi = "http://192.168.1.219:80/restfull" //MARIO PHP
 const urlApi = "https://bsntor.com.mx/Sistema/restfull" // BOMBAS


// const urlUsuarios = `${urlAPI}/usuario`
//  const urlLogin = `${urlApi}/User/login`

export default new Vuex.Store({


    state:{

        // JSON
        datos:null,
        urlAPI: urlApi
    },

// ------------------------------------------------------------------    
    getters: {

        // BOOLEANO
        sesionIniciada ( state ) {
            return !!state.datos
        },

        // STRING
        getUsuarioID( state ) {
            return state.datos.USUARIO_ID;
        },

        // STRING
        getUsuario( state ) {
            return state.datos.USUARIO;
        },

        getNombreCompletoUsuario( state ){
            return  state.datos.NOMBRE     + ' ' +
                    state.datos.APELLIDO_P + ' ' +
                    state.datos.APELLIDO_M; 
        },

        // INTEGER
        getRolUsuario( state ) {
            return state.datos.ROL_ID;
        },

        // ARRAY
        getRolesUsuario( state ) {
            return state.datos.CLAVE;
        },

        getURLAPI ( state ) {
            return state.urlAPI;
        },

        getFechaActual (){
            const d = new Date;
            var año = '' + d.getFullYear(),
                mes = '' + (d.getMonth() +1),
                dia = '' + d.getDate();

                if (mes.length < 2)
                    mes = '0' + mes;
                if (dia.length < 2)
                    dia = '0' + dia;
                
            var fecha = [   año,
                            mes,
                            dia] .join('-')
                            +' '+
                        [   d.getHours(),
                            d.getMinutes(),
                            d.getSeconds() ] .join(':');
    
            return fecha;
            
        },
        // ------------------------------------------------------------------------------
        cortarString(string, tamaño) {
            return string.length > tamaño
            ? string.substring(0, tamaño) + "..."
            : string;
        },

        getHoraActual(){
            return horaActual();
        }
    },
// ------------------------------------------------------------------    

    mutations: {

        // Guarda los datos del usuario obtenidos desde el servidor,
        // en los campos:
        // - state.datos, localstorage 
        SET_DATOS_USUARIO( state , datos ) {
            state.datos = datos
            state.datos.FECHA = horaActual();
            localStorage.setItem( 'usuario', JSON.stringify( datos ) )
        },


        BORRAR_DATOS_USUARIO(  ) {
            localStorage.removeItem('usuario')
            location.reload()
        },

        // --------------------------------------------------------------------
        // Al recargar la pagina, recuperar los datos guardados en localStorage
        RECUPERAR_DATOS_USUARIO( state ) {

            //asignar state.usuario = desde localstorage.getitem
            if( localStorage.getItem('usuario') != null )
            {
                let datos = JSON.parse(localStorage.getItem('usuario'));
                let tiempo = new Date().getTime() - datos.FECHA;
                
                if ( tiempo <= 3600000 ) {
                    state.datos = datos;
                }else{
                    console.log(tiempo);
                    localStorage.removeItem('usuario')
                    alert("Sesion terminada por inactividad...");
                    location.reload()
                }
            }
            else{
                state.datos = null;
            }
            
        },

        // --------------------------------------------------------------------
        ACTUALIZAR_FECHA_ACTIVIDAD( state ) {
            if( localStorage.getItem('usuario') != null )
            {
                let time = new Date().getTime();
                
                state.datos.FECHA = time;
                localStorage.setItem('usuario',JSON.stringify( state.datos ));
            }
        }
        

    },

// ------------------------------------------------------------------    

    actions:{

        login( { commit }, data ) {
            commit('SET_DATOS_USUARIO', data)
        },

        cerrarSesion({ commit }){
            commit( 'BORRAR_DATOS_USUARIO')
        },

        recuperarSesion({ commit }) {
            commit( 'RECUPERAR_DATOS_USUARIO' )
        },

        actualizarFechaActividad({ commit }) {
            commit ( 'ACTUALIZAR_FECHA_ACTIVIDAD' )
        }

        


    },

// ------------------------------------------------------------------


    


})